import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'crm-search/search';
export const GET_ASSOCIATED_CAMPAIGN_FIELD_NAME = 'associatedCampaign';
export const GET_ASSOCIATED_CAMPAIGN = registerQuery({
  fieldName: GET_ASSOCIATED_CAMPAIGN_FIELD_NAME,
  args: ['formGuid'],
  fetcher({
    formGuid
  }) {
    return http.post(BASE_URL, {
      data: {
        count: 1,
        objectTypeId: '0-28',
        requestOptions: {
          properties: ['hs_marketing_campaign_guid']
        },
        filterGroups: [{
          filters: [{
            property: 'hs_form_id',
            value: formGuid,
            operator: 'EQ'
          }]
        }]
      }
    }).then(({
      results: [crmObject]
    }) => crmObject.properties.hs_marketing_campaign_guid ? crmObject.properties.hs_marketing_campaign_guid.value : null);
  }
});
export function useFetchAssociatedCampaign({
  formGuid,
  skip
}) {
  const {
    data,
    error,
    loading
  } = useQuery(GET_ASSOCIATED_CAMPAIGN, {
    variables: {
      formGuid
    },
    skip
  });
  return useMemo(() => ({
    data: data && data[GET_ASSOCIATED_CAMPAIGN_FIELD_NAME],
    error,
    loading
  }), [data, error, loading]);
}